<div class="wrapper">
	<div>
		<fa-icon icon="spinner" animation="spin" size="4x"></fa-icon>
		<h3>{{ message }}</h3>
	</div>
</div>
